app.controller(
    'AdminUserCreationPwdController', ['$scope', '$rootScope', '$http', '$stateParams', '$timeout', 'toastr', '$document', 'Configuration', 'UserService', '$sce', '$translate', AdminUserCreationPwdController]
);

function AdminUserCreationPwdController($scope, $rootScope, $http, $stateParams, $timeout, toastr, $document, Configuration, UserService, $sce, $translate) {
    var vm = this;

}

